export default "__VITE_ASSET__32fcfca7__"